module.exports = __webpack_public_path__ + "media/flags/nl-flag-ccab9388.svg";